import { Props } from './Footer.models';

export const INIT_PROPS: Props = Object.freeze({
  className: '',
});
